import axios from 'axios';
import {
  TaskData,
  CreateTaskRequest,
  UpdateTaskRequest,
  GetTasksQuery,
} from '../types/task';

const BASE = '/api/tasks';

export const taskService = {
  create: async (data: CreateTaskRequest): Promise<TaskData> => {
    const res = await axios.post(BASE, data, { withCredentials: true });
    return res.data.data;
  },

  getAll: async (query?: GetTasksQuery): Promise<{ data: TaskData[]; meta: any }> => {
    const res = await axios.get(BASE, { params: query, withCredentials: true });
    return res.data;
  },

  getById: async (id: number): Promise<TaskData> => {
    const res = await axios.get(`${BASE}/${id}`, { withCredentials: true });
    return res.data.data;
  },

  update: async (id: number, data: UpdateTaskRequest): Promise<TaskData> => {
    const res = await axios.patch(`${BASE}/${id}`, data, { withCredentials: true });
    return res.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await axios.delete(`${BASE}/${id}`, { withCredentials: true });
  },
};
